import { z } from "zod";

export const timeSlotSchema = z
	.object({
		start_time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, { message: "Time must be in HH:mm format" }),
		end_time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, { message: "Time must be in HH:mm format" }),
	})
	.strict()
	.refine((slot) => slot.start_time < slot.end_time, { message: "Start time must be before end time" });

export type TimeSlot = z.infer<typeof timeSlotSchema>;

export const weeklyScheduleEntrySchema = z
	.object({
		day_of_week: z.number().int().min(0).max(6),
		slots: z.array(timeSlotSchema).max(10),
	})
	.strict();

export type WeeklyScheduleEntry = z.infer<typeof weeklyScheduleEntrySchema>;

export const setWeeklyScheduleSchema = z
	.object({
		schedule: z.array(weeklyScheduleEntrySchema).max(7),
	})
	.strict();

export type SetWeeklySchedulePayload = z.infer<typeof setWeeklyScheduleSchema>;

export const addUnavailableDateSchema = z
	.object({
		date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, { message: "Date must be in YYYY-MM-DD format" }),
	})
	.strict();

export type AddUnavailableDatePayload = z.infer<typeof addUnavailableDateSchema>;

export interface AvailabilitySlot {
	id: string;
	day_of_week: number;
	start_time: string;
	end_time: string;
}

export interface UnavailableDate {
	id: string;
	date: string;
}

export interface UserAvailability {
	weekly_schedule: AvailabilitySlot[];
	unavailable_dates: UnavailableDate[];
}

export const DAY_KEYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"] as const;

export type DayKey = (typeof DAY_KEYS)[number];
